module.exports = __webpack_public_path__ + "media/application/images/checkbox-white-2b03794eb3f72a25395a4b00590416b2.svg";